module.exports = __webpack_public_path__ + "media/components/country-flag/static/ml-ee8bf9988898675899674da260cb2ae3.svg";